module.exports = __webpack_public_path__ + "img/member.d9278aeb.svg";